module.exports = __webpack_public_path__ + "static/media/logo1.34f936d5.png";